import React from "react";

interface Props {
  className?: string;
}

export const Swapicon: React.FC<Props> = ({ className = "" }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="126"
      viewBox="0 0 126 126"
      width="126"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.1171 68.6016L57.5 67.9844L62.3829 63.1016L57.5 58.2187L58.1171 57.6016L63 62.4844L67.8829 57.6016L68.5 58.2187L63.6171 63.1016L68.5 67.9844L67.8829 68.6016L63 63.7187L58.1171 68.6016Z"
        className="fill-[var(--fy-grey-light)]"
      />
    </svg>
  );
}; 